// Mock data for Strategy Intelligence Solutions website

export const companyInfo = {
  name: "Strategy Intelligence Solutions",
  tagline: "Artificial Intelligence Strategy, Consulting & Solutions",
  email: "contact@si-solutions.ai",
  phone: "+852 6272 6835",
  address: "128, City Road, London EC1V 2NX, United Kingdom"
};

export const heroContent = {
  announcement: "AI Strategy & Consulting",
  title: "Artificial Intelligence Strategy, Consulting & Solutions",
  subtitle: "Strategy Intelligence Solutions LTD is an artificial intelligence consulting firm dedicated to helping companies and individuals design, evaluate, and deploy effective AI strategies.",
  cta: "Get Started",
  secondaryCta: "Learn More"
};

export const aboutContent = {
  title: "About the Company",
  paragraphs: [
    "Strategy Intelligence Solutions is headquartered in London and operates internationally.",
    "Our core mission is to provide high-level consulting in artificial intelligence, supporting organizations and individuals in understanding AI opportunities, assessing project feasibility, and making informed strategic decisions.",
    "We also act as a holding and strategic partner for AI-driven SaaS platforms, including proprietary solutions such as Do Not Bull."
  ]
};

export const services = [
  {
    id: 1,
    title: "AI Strategy Consulting",
    description: "Defining clear, realistic, and scalable AI strategies aligned with business or personal objectives.",
    accent: "purple"
  },
  {
    id: 2,
    title: "AI Project & Dossier Evaluation",
    description: "Reviewing AI projects, concepts, and technical documentation to assess viability, innovation potential, and long-term development prospects.",
    accent: "blue"
  },
  {
    id: 3,
    title: "Artificial Intelligence Solutions",
    description: "Designing and recommending tailored AI solutions for companies and individuals, from automation to intelligent systems.",
    accent: "orange"
  },
  {
    id: 4,
    title: "AI SaaS & Digital Platforms",
    description: "Development, ownership, and strategic oversight of AI-based SaaS products and services.",
    accent: "green"
  }
];

export const clientTypes = [
  {
    id: 1,
    title: "Companies & Startups",
    description: "Organizations exploring or scaling artificial intelligence"
  },
  {
    id: 2,
    title: "Enterprises",
    description: "Seeking expert validation of AI initiatives"
  },
  {
    id: 3,
    title: "Entrepreneurs & Innovators",
    description: "Developing AI projects and seeking guidance"
  },
  {
    id: 4,
    title: "Individuals",
    description: "Looking for personalized AI solutions or guidance"
  }
];

export const approachContent = {
  title: "Our Approach",
  description: "We combine strategic insight, technical understanding, and business vision to deliver AI solutions that are ethical, efficient, and future-ready.",
  tagline: "Our approach is pragmatic, confidential, and focused on long-term value creation."
};

export const whyChooseUs = [
  "Independent and objective AI expertise",
  "Strategic, not purely technical, perspective",
  "Experience across consulting, SaaS, and AI innovation",
  "Solutions adapted to both businesses and individuals",
  "Global reach with international operations"
];

export const closingStatement = {
  title: "Ready to Transform with AI?",
  description: "Strategy Intelligence Solutions supports the intelligent adoption of artificial intelligence — from strategy and evaluation to execution and innovation.",
  tagline: "Artificial intelligence, guided by strategy."
};

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Clients", href: "#clients" },
  { label: "Approach", href: "#approach" },
  { label: "Contact", href: "#contact" }
];
